import { Component, Input, Output, EventEmitter, HostListener, forwardRef, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ZipFlagListOptions } from './zip-code-flag-input.model';

@Component({
  selector: 'app-zip-code-flag-input',
  templateUrl: './zip-code-flag-input.component.html',
  styleUrls: ['./zip-code-flag-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ZipCodeFlagInputComponent),
      multi: true
    }
  ]
})

export class ZipCodeFlagInputComponent implements ControlValueAccessor {
  public readonly flagOptions = ZipFlagListOptions;
  @Input() selectedOption = 0;
  @Input() placeholder = '00000-000';
  @Input() isOpen = false;
  @Input() invalid = false;
  @Output() changeFlagValue: EventEmitter<any> = new EventEmitter<any>();
  private val = '';

  @HostListener('window:click', ['$event'])
  onClick(ev) {
    if (this.isOpen) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpen = false;
      }
    }
  }

  constructor(private eRef: ElementRef) { }

  onChange: any = () => {};
  onTouch: any = () => {};

  get value() {
    return this.val;
  }

  set value(val) {
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  changeFlag(index: number) {
    this.isOpen = false;
    this.changeFlagValue.emit(this.flagOptions[index]);
  }
}
